const BENEFITS = [
  {
    icon: 'ri-time-line',
    title: 'Save Hours Every Week',
    body: 'Stop spending evenings trying to write ads or figure out targeting. AdForge does it in minutes so you can focus on running your business.',
    metric: '6+ hrs/week saved',
  },
  {
    icon: 'ri-shopping-bag-line',
    title: 'Get More Customers',
    body: 'AI-written copy is tested and optimized for conversions. Better ads mean more foot traffic, more online orders, and more booked appointments.',
    metric: 'Avg. 2.6x more customers',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Better Performing Ads',
    body: 'AdForge uses proven ad frameworks — problem/solution, social proof, urgency — so your small business advertising actually converts browsers into buyers.',
    metric: '3.4x avg. ROAS',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Stop Wasting Ad Budget',
    body: 'Bad copy burns money. AI-generated ads are built to perform from day one, so every dollar you spend works harder for your business.',
    metric: '55% lower cost per customer',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'No Agency Fees',
    body: 'Agencies charge $1,000–$5,000/month for what AdForge does in minutes. Keep that money in your business where it belongs.',
    metric: 'Save $12k+/year',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Unlimited Variations',
    body: 'Test different hooks, headlines, and images without starting over. Regenerate any element with one click and find what resonates with your audience.',
    metric: 'Unlimited A/B testing',
  },
];

export default function SmallBusinessBenefits() {
  return (
    <section className="py-20 lg:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Why Small Businesses Choose AdForge
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
            Real Benefits for Real Business Owners
          </h2>
          <p className="text-base text-stone-400 max-w-xl mx-auto">
            AdForge isn&apos;t just another marketing tool. It&apos;s built specifically for{' '}
            <strong className="text-white">small businesses</strong> that need results, not complexity.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b) => (
            <div
              key={b.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4 hover:bg-white/8 transition-colors duration-200"
            >
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400 flex-shrink-0">
                  <i className={`${b.icon} text-xl`} />
                </div>
                <h3 className="text-base font-bold text-white leading-snug">{b.title}</h3>
              </div>
              <p className="text-sm text-stone-400 leading-relaxed">{b.body}</p>
              <div className="mt-auto pt-4 border-t border-white/10">
                <span className="text-sm font-black text-orange-400">{b.metric}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
